<template>
  <div class="property-reviews__list">
    <div v-for="review in reviews" :key="review.id" class="property-review">
      <div class="property-review__top">
        <div class="property-review__top-avatar">
          <div class="avatar-placeholder">
            {{review.author?.firstname?.[0]?.toUpperCase() || ''}}
          </div>
        </div>
        <div class="property-review__top-details">
          <div class="text-body-1 fw-semi-bold">
            {{review.author?.firstname || 'User'}}
          </div>
          <div class="text-body-2 color-dark-grey">
            {{review.formattedDate}}
          </div>
        </div>
        <div class="property-review__top-value">
          <span :class="['review-value-block', ratingClass(review.rating)]">
            {{review.rating}}
          </span>
        </div>
      </div>
      <div class="property-review__title text-body-1 fw-semi-bold">
        {{review.title || ''}}
      </div>
      <div class="property-review__text text-body-2">
        {{review.content}}
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">

const {
  reviews
} = defineProps(['reviews'])

function round(rating:number) {
  return  ((rating ^ 0) === rating) ? (+rating).toFixed() : (+rating).toFixed(1)
}

const ratingClass = (rating:number) => {
  if (rating) {
    if (rating >= 9) {
      return 'excellent'
    } else if (rating >= 7) {
      return 'very-good'
    } else if (rating >=6) {
      return 'good'
    } else if (rating >= 4) {
      return 'fair'
    } else if (rating > 0) {
      return 'poor'
    }
  }
  return 'no-reviews'
}

</script>
<style lang="scss" scoped>
.property-reviews__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  .property-review {
    display: flex;
    flex-direction: column;
    gap: 12px;
    background-color: var(--light-grey);
    padding: 12px;
    border-radius: 8px;
    .property-review__top {
      display: flex;
      gap: 12px;
      align-items: center;
      .property-review__top-avatar {
        .avatar-placeholder {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 56px;
          height: 56px;
          background: var(--blue-highlight);
          color: var(--blue);
          border-radius: 50%;
          font-size: 16px;
        }
      }
      .property-review__top-details {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }
}
.review-value-block {
  width: 40px;
  min-width: 40px;
  height: 40px;
  min-height: 40px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--black);
  color: var(--white);
  font-size: 16px;
  font-weight: 500;

  &.excellent {
    background: var(--green);
  }

  &.very-good, &.good {
    background: var(--light-green);
  }

  &.poor, &.fair {
    background: var(--black);
  }
}
</style>
